const EquivalencyLookup = {
    HOME: {
        icon: 'home',
        description: 'Homes\' electricity use for one year',
        info: 'In 2015, the average annual electricity consumption for a U.S. residential utility customer was 10,812 kWh, an average of 901 kWh per month. XX million kilowatt-hours (kWh) of green power is the equivalent to the annual power usage of XX average American homes.',
        calc (input) {
            return (input / 10715).toFixed(8);
        },
    },
    AUTOMOTIVE: {
        icon: 'car',
        description: 'Miles driven by electric car',
        info: 'Lorem ipsum',
        calc (input) {
            return ((input * 100) / 34.6).toFixed(8);
        },
    }
};

export default EquivalencyLookup;



/** WEBPACK FOOTER **
 ** ./src/redux/modules/equivalencies/EquivalencyLookup.js
 **/